export default __webpack_public_path__ + "media/project-management-vector.9c856cb8f2e61ac71da7ad45735b6d1e.svg";